const root = "/propertyManagement/threeDayNotice";
const threeDayNotice = {
  threeDayNoticeList: `${root}/list`,
  threeDayNoticeDetail: `${root}/detail`,
  threeDayNoticeLedger: `${root}/ledger`,
  threeDayNoticePreview: `${root}/preview`,
  threeDayNoticeDownload: `${root}/download`,
};
export default threeDayNotice;
